import { get, post, put, patch, remove } from "./utils";

export const announcement = {
  listLatestAnnouncement: (parameters, token) => {
    return get(
      "/api/announcement/announcements/my_receive/",
      parameters,
      token
    );
  },
  listMyDraftAnnouncement: (parameters, token) => {
    return get("/api/announcement/announcements/my_draft/", parameters, token);
  },
  listMyReceiveAnnouncement: (parameters, token) => {
    return get(
      "/api/announcement/announcements/my_receive/",
      parameters,
      token
    );
  },
  listPublishedAnnouncement: (parameters, token) => {
    return get(
      "/api/announcement/announcements/list_published/",
      parameters,
      token
    );
  },
  getAnnouncement: (id, token) => {
    return get(`/api/announcement/announcements/${id}/`, {}, token);
  },
  createAnnouncement: (parameters, token) => {
    return post("/api/announcement/announcements/", parameters, token);
  },
  updateAnnouncement: (id, parameters, token) => {
    return put(`/api/announcement/announcements/${id}/`, parameters, token);
  },
  removeAnnouncement: (id, token) => {
    return remove(`/api/announcement/announcements/${id}/`, {}, token);
  },
  publishAnnouncement: (id, token) => {
    return post(`/api/announcement/announcements/${id}/publish/`, {}, token);
  },
  recallAnnouncement: (id, token) => {
    return post(`/api/announcement/announcements/${id}/recall/`, {}, token);
  },
  finishAnnouncement: (id, token) => {
    return patch(
      `/api/announcement/announcements/${id}/read/`,
      { status: 1 },
      token
    );
  },
};
